import { getBackendRoot } from "@/lib/api";

function apiPrefix() {
  const root = getBackendRoot();
  return root ? `${root}/api` : "/api";
}

const PROXIED_HOSTS = new Set([
  "images.unsplash.com",
  "unsplash.com",
  "plus.unsplash.com",
  "cdn.pixabay.com",
  "images.pexels.com",
]);

export function proxied(url) {
  if (!url || typeof url !== "string") return url;
  if (url.startsWith("/api/")) return resolveMediaUrl(url);
  if (!url.startsWith("http")) return url;
  try {
    const u = new URL(url);
    if (!PROXIED_HOSTS.has(u.hostname)) return url;
    return `${apiPrefix()}/img?url=${encodeURIComponent(url)}`;
  } catch (_) {
    return url;
  }
}

/** Relatív /api/files/… vagy külső URL → megjeleníthető abszolút cím. */
export function resolveMediaUrl(url) {
  if (!url || typeof url !== "string") return url;
  if (url.startsWith("http")) return proxied(url);
  if (url.startsWith("/api/")) {
    const root = getBackendRoot();
    return root ? `${root}${url}` : url;
  }
  return url;
}
